import React, { useEffect, useRef, useState } from 'react';
import { useWallet } from '../../context/WalletContext';
import { useContracts } from '../../context/ContractContext';
import Card from '../common/Card';
import InlineLoader from '../common/InlineLoader';
import { formatUSDT } from '../../utils/format';

const AWARDS = [
  { name: 'Gold Coin 1g',                     value: '$150',    icon: '◉' },
  { name: 'Mobile 5G',                        value: '$250',    icon: '▤' },
  { name: 'Tab',                              value: '$350',    icon: '▢' },
  { name: 'Laptop',                           value: '$500',    icon: '◱' },
  { name: 'Bike Fund',                        value: '$800',    icon: '⚙' },
  { name: 'Car Fund',                         value: '$2,000',  icon: '⛨' },
  { name: 'Car Fully Paid',                   value: '$6,000',  icon: '⛨' },
  { name: 'House Fund',                       value: '$20,000', icon: '⌂' },
  { name: 'Luxury Car',                       value: '$50,000', icon: '★' },
  { name: 'Luxury Villa',                     value: '$100,000',icon: '♛' },
  { name: 'Reward + Company Royalty 2% T/O',  value: 'Royalty', icon: '♕' }
];

export default function RewardTiers() {
  const { account } = useWallet();
  const { main, views } = useContracts();
  const [loading, setLoading] = useState(true);
  const [tiers, setTiers] = useState([]);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    const load = async () => {
      try {
        const reqs = await views.getRewardReqs();
        let elig = new Array(11).fill(false);
        let given = new Array(11).fill(false);
        if (account) {
          const uid = await main.addrToId(account);
          if (!uid.eq(0)) {
            const s = await main.getUserRewardStatus(uid);
            elig = s[0]; given = s[1];
          }
        }
        if (!mountedRef.current) return;
        const out = [];
        for (let i = 0; i < 11; i++) {
          out.push({
            i,
            teamBiz: reqs.tb[i],
            selfStake: reqs.ss[i],
            eligible: elig[i],
            given: given[i],
            award: AWARDS[i]
          });
        }
        setTiers(out);
        setLoading(false);
      } catch (_) {
        if (mountedRef.current) setLoading(false);
      }
    };
    setLoading(true);
    load();
    return () => { mountedRef.current = false; };
  }, [account, main, views]);

  if (loading) return <Card title="Reward Tiers"><InlineLoader /></Card>;

  return (
    <Card title="Reward Tiers · 11 Levels" glow>
      <div className="table-wrap table-scroll">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Award</th>
              <th className="text-right">Team Biz</th>
              <th className="text-right">Self Topup</th>
              <th className="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            {tiers.map((t) => {
              const statusCls = t.given ? 'badge badge-warning' : t.eligible ? 'badge badge-success' : 'badge badge-muted';
              const statusText = t.given ? 'CLAIMED' : t.eligible ? 'ELIGIBLE' : 'LOCKED';
              const rowGlow = t.given ? { background: 'rgba(255, 184, 0, 0.05)' } :
                              t.eligible ? { background: 'rgba(0, 255, 136, 0.05)' } : {};
              return (
                <tr key={t.i} style={rowGlow}>
                  <td><span className="level-num">L{t.i + 1}</span></td>
                  <td>
                    <div className="flex items-center gap-3">
                      <span className="text-warning" style={{ fontSize: 18 }}>{t.award.icon}</span>
                      <div>
                        <div className="text-primary" style={{ fontWeight: 700, letterSpacing: 0.5 }}>{t.award.name}</div>
                        <div className="text-dim" style={{ fontSize: 11 }}>{t.award.value}</div>
                      </div>
                    </div>
                  </td>
                  <td className="text-right text-success">${formatUSDT(t.teamBiz, 0)}</td>
                  <td className="text-right">${formatUSDT(t.selfStake, 0)}</td>
                  <td className="text-center"><span className={statusCls}>{statusText}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
